
import React, { useState, useEffect, MouseEvent } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField,
    Popover
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {useTheme} from '@mui/material/styles';
import {LayoutFieldModel} from '../../models/models';
import {validateUrlField} from '../../utils/fieldValidations';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';
import QRCode from 'qrcode';

export const UrlQRCodePreview = ({
  url
}: {
  url: string | null | undefined
}) => {
  const [src, setSrc] = useState<string>("");
  useEffect(() => {
    if(url){
      QRCode.toDataURL(url)
        .then(setSrc)
        .catch(console.error)
    }
  }, [url])

  if(src){

    return (
      <Box sx={{ p: 1, maxWidth: 600, maxHeight: 600 }}>
        <Box
          component="img"
          src={src}
          alt="QR Code"
          sx={{
            display: 'block',
            width: '100%',
            height: 'auto',
            maxHeight: 260,
            objectFit: 'contain',
            borderRadius: 4
          }}
        />
      </Box>
    )
  }
  return null
}




export const UrlFieldComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: string,
  onChange: (value: string, layoutField: LayoutFieldModel) => void,
}> = ( {
  layoutField,
  value,
  onChange
}) => {

  const styles = ContainerClasses();

  const searchFieldContainer = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  }

  /*********QRCODE ELEMENT**************/

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handlePreviewEnter = (e: MouseEvent<HTMLElement>) => {
    //for now, only set anchor element when image
    const target = e.target as HTMLElement;
    if (target.closest('button')) {
      setAnchorEl(null)
      return; // ignore hover over any button/icon
    }

    if(value){
      setAnchorEl(e.currentTarget);
    }
  };
  const handlePreviewLeave = () => setAnchorEl(null);

  /****************************/

  const required = checkLayoutFieldRequirement(layoutField);

  const [error, setError] = useState(required && (value === undefined || value === null || value === ""));

  const handleChange = (event: any) => {
    const value = event.target.value;

    if(required &&
      (value === undefined || value === null || value === "")){
        setError(true)
    } else {
      const patternMatched = validateUrlField(value)
      setError(!patternMatched);
    }

    onChange(value, layoutField);

  }

  const getUrl = (url: string | null | undefined) => {
    if(url === null || url === undefined) return '';
    if(url.startsWith('http://')) return url;
    if(url.startsWith('https://')) return url;
    return `https://${url}`;
  }

  return (

    <Box
      onMouseLeave={handlePreviewLeave}
      onMouseEnter={handlePreviewEnter}
      sx={{
        display: 'inline-block',
        width: '100%'
      }}
    >
      <TextField
         fullWidth
         error={error}
         disabled={layoutField.AccessSetting_sys === 'read'}
         multiline={false}
         rows={1}
         required={checkLayoutFieldRequirement(layoutField)}
         size="small"
         label={`${layoutField.ReferencedField_sys.Label_sys} (max. ${layoutField.ReferencedField_sys.Length_sys})`}
         variant="filled"
         value={value}
         onChange={(event) => handleChange(event)}
         helperText={layoutField.ReferencedField_sys.HelpText_sys}
         inputProps={{
           maxLength: layoutField.ReferencedField_sys.Length_sys,
         }}
         InputProps={{
           endAdornment: (
              <InputAdornment position="end">
                 <IconButton
                    disabled = {value === undefined || value == null || value === ""}
                    component="a"
                    size="small"
                    target="_blank"
                    href={getUrl(value)}
                    >
                 <OpenInNewIcon />
                </IconButton>
            </InputAdornment>
        )
      }}
      />

      <Popover
        sx={{ pointerEvents: 'none' }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        onClose={handlePreviewLeave}
        disableRestoreFocus
        disableScrollLock
      >
        {
          value &&
          <UrlQRCodePreview
            url={getUrl(value)}
          />
        }

      </Popover>
    </Box>
    );

};
